export function appendClass(el, classRecord) {
    for (const className in classRecord) {
        if (classRecord[className] && !el.classList.contains(className)) {
            el.classList.add(className);
        }
        if (!classRecord[className] && el.classList.contains(className)) {
            el.classList.remove(className);
        }
    }
}
//# sourceMappingURL=append-class.js.map